import { lazy } from "react";

export const HomePage = lazy(() => import("../pages/home"));
export const ServicePage = lazy(() => import("../pages/service"));
export const ProjectPage = lazy(() => import("../pages/project"));
export const ContactPage = lazy(() => import("../pages/contact"));
export const AboutPage = lazy(() => import("../pages/about"));
